
<!--
 * @Description: 教职工详情 社会兼职
 * @Author: 张天伟
 * @Date: 2023-03-08 11:59:14
 * @LastEditors: PF
 * @LastEditTime: 2024-10-15 16:38:39
-->
<template>
  <div>
    <el-descriptions v-for="(item, index) in tableData" :key="index" :column="4" border>
      <el-descriptions-item label="社会兼职" label-align="right" align="left" width="160px" span="2">{{item.shjzbt}}</el-descriptions-item>
      <el-descriptions-item label="社会兼职起始日期" label-align="right" align="left" width="160px" span="2">{{item.shjzqsrq}}</el-descriptions-item>
      <el-descriptions-item label="社会兼职结束日期" label-align="right" align="left" width="160px" span="2">{{item.shjzzzrq}}</el-descriptions-item>
      <el-descriptions-item label="社会兼职辞职原因" label-align="right" align="left" width="160px" span="2">{{item.shjzczyybt}}</el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({ row: { type: Object, required: false } })
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = { url: '/api/v2/renliziyuan/jiaozhigongshehuijianzhi/list', data: { id: props.row.id, order: 'gh', sort: 'asc' } }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
